import { Layout } from "../components/Layout";
import { Card } from "../components/Card";
import "./LegalPage.css";

export function PrivacyPage() {
  return (
    <Layout>
      <div style={{ marginBottom: "var(--space-5)" }}>
        <span className="label">Effective May 2026</span>
        <h1 style={{ marginTop: "6px" }}>Privacy Policy</h1>
      </div>
      <Card>
        <article className="legal">
          <p>
            Retrofit AI Systems ("we", "us") operates the Retrofit AI Monitor service ("the Service"). This policy
            describes what data the Service collects, why, how long we keep it, and how you can request its deletion.
          </p>

          <h2>1. Data we collect</h2>
          <p>The Service collects two categories of data:</p>
          <p>
            <strong>Account data</strong> (provided by you when you sign up): the email address you used to sign in, a
            randomly-generated client identifier, and the timestamp of sign-up.
          </p>
          <p>
            <strong>Meta advertising data</strong> (retrieved on your behalf via Facebook's Marketing API after you grant
            access through Facebook Login for Business): the IDs and names of the ad accounts you authorized, and
            campaign-level performance metrics for the trailing rolling window — including spend, impressions, clicks,
            click-through rate, cost per impression, cost per click, conversions, revenue, return on ad spend,
            frequency, and reach. We do not collect ad creatives, audience definitions, the contents of any messages,
            or personal information about the people who saw your ads.
          </p>

          <h2>2. Why we collect each category</h2>
          <ul>
            <li>
              <strong>Account data</strong> is collected to identify you when you sign in, scope all data and alerts
              to your account only, and email you when something requires your attention.
            </li>
            <li>
              <strong>Meta advertising data</strong> is collected so the Service can evaluate your configured rules
              against current performance and notify you when a threshold is crossed.
            </li>
          </ul>

          <h2>3. Authorization and the Meta access token</h2>
          <p>
            When you click "Connect Meta," you are redirected to Facebook's login screen and asked to authorize{" "}
            <code>ads_read</code> and <code>business_management</code>. After you approve, Facebook issues us a
            long-lived system user token that the Service uses to pull the metrics described above on your behalf. The
            token is stored encrypted at rest using authenticated encryption (AES-GCM). You can revoke our access at any
            time from your Facebook Business Manager settings, and we will mark your account as <em>needs reconnect</em>{" "}
            on the next polling cycle.
          </p>

          <h2>4. Retention</h2>
          <p>
            Account data is retained for the lifetime of your account. Campaign performance metrics are retained for 90
            days from the date they cover; older daily metrics are deleted on a rolling basis. Alert history (the record
            of which alerts fired and when) is retained for 365 days for audit. If you request deletion of your
            account, all of the above is deleted within 30 days.
          </p>

          <h2>5. Sharing</h2>
          <p>
            We do not sell your data and we do not share it with third parties for advertising or analytics. The data is
            handled only by the following named processors, each acting on our behalf under their respective
            data-processing terms:
          </p>
          <ul>
            <li>
              <strong>Cloudflare Inc.</strong> — application hosting (Workers) and database storage (D1).
            </li>
            <li>
              <strong>Resend</strong> — outbound email delivery (alert digests and account notifications).
            </li>
            <li>
              <strong>Telegram FZ-LLC</strong> — outbound alert delivery, only if you choose to enable Telegram
              notifications and link a chat ID.
            </li>
            <li>
              <strong>Meta Platforms, Inc.</strong> — the upstream source of your ad performance data. We only read; we
              do not push data back into Meta.
            </li>
          </ul>

          <h2>6. Your rights</h2>
          <p>
            You can request export or deletion of all data associated with your account by emailing{" "}
            <a href="mailto:privacy@retrofitaisystems.com">privacy@retrofitaisystems.com</a>. We will respond within 14
            days and complete deletion within 30 days of the request. You can also disconnect your Meta account at any
            time from the Service dashboard, which immediately stops new data collection.
          </p>

          <h2>7. Security</h2>
          <p>
            Meta access tokens are encrypted at rest with AES-GCM authenticated encryption. All traffic between you, the
            Service, and Meta uses HTTPS. We never log access tokens.
          </p>

          <h2>8. Changes to this policy</h2>
          <p>
            If we materially change what data we collect or how we use it, we will update the date at the top of this
            page and email account owners at least 14 days before the change takes effect.
          </p>

          <h2>9. Contact</h2>
          <p>
            For privacy questions or data requests, contact{" "}
            <a href="mailto:privacy@retrofitaisystems.com">privacy@retrofitaisystems.com</a>.
          </p>
        </article>
      </Card>
    </Layout>
  );
}
